import * as GET_BUYING_SESSION_PRODUCT_RATING from './getBuyingSessionProductRating.graphql'

export { GET_BUYING_SESSION_PRODUCT_RATING }
